import {useSelector} from 'react-redux'
import {getOfferEntity} from 'modules/sapiSearch/selectors'
import {hasFreezableTopOffer} from 'modules/sapiSearch/utils'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

/**
 * Added as a part of c747927f-deal-freeze-srp.
 */
export const useShouldShowDealFreezeBanner = ({
  hotelId
}: {
  hotelId: string
}): boolean => {
  const toggle = useToggle()
  const offerEntity = useSelector(state => getOfferEntity(state, hotelId))
  const hasFreezableOffer = hasFreezableTopOffer(offerEntity)
  if (hasFreezableOffer) return toggle('c747927f-deal-freeze-srp', false, true)
  return false
}
